import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initializeCacheManagement } from './utils/cacheManager'

// Remove loading spinner once app is ready
const removeLoadingSpinner = () => {
  const spinner = document.querySelector('.loading-spinner');
  if (spinner) {
    spinner.remove();
  }
};

// Render app immediately - no deferred initialization
const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Remove spinner after first render
removeLoadingSpinner();

// Initialize cache management for repeat visits
initializeCacheManagement();

// Defer all non-critical initialization to idle time
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    // Prefetch likely next pages
    const prefetchPages = ['/rooms', '/blog', '/contact'];
    prefetchPages.forEach(page => {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = page;
      document.head.appendChild(link);
    });
  }, { timeout: 3000 });
}
